import {
	TAILORED_ONBOARDING_SUMMARY,
	TAILORED_ONBOARDING_LIST,
	TAILORED_ONBOARDING_TIMELINE,
	TAILORED_ONBOARDING_PAGES,
	TAILORED_ONBOARDING_FORMS,
	TAILORED_ONBOARDING_INVITE,
} from '../../../../common/constants.tsx';
import type { Cards, TaskList } from '../../../../common/types.tsx';
import { messages } from './messages.tsx';
import { PROJECT_MANAGEMENT_VARIANTS } from './project-management/index.tsx';
import { PRODUCT_MANAGEMENT_VARIANTS } from './product-management/index.tsx';
import { DESIGN_VARIANTS } from './design/index.tsx';
import { IT_SUPPORT_VARIANTS } from './it-support/index.tsx';
import { OTHER_PERSONAL_VARIANTS } from './other-personal/index.tsx';
import { MARKETING_VARIANTS } from './marketing/index.tsx';
import { OPERATIONS_VARIANTS } from './operations/index.tsx';
import { EVERYTHING_ELSE_VARIANTS } from './everything-else/index.tsx';

export const TASK_LIST: TaskList = Object.freeze({
	root: {
		title: messages.rootTitle,
		items: [
			TAILORED_ONBOARDING_SUMMARY,
			TAILORED_ONBOARDING_LIST,
			TAILORED_ONBOARDING_TIMELINE,
			TAILORED_ONBOARDING_PAGES,
			TAILORED_ONBOARDING_FORMS,
			TAILORED_ONBOARDING_INVITE,
		],
	},
});

// https://hello.atlassian.net/wiki/spaces/agile/pages/1093679513/Documentation+QS+Card+manager
export const TASK_VARIANTS: Cards = {
	...PRODUCT_MANAGEMENT_VARIANTS,
	...PROJECT_MANAGEMENT_VARIANTS,
	...DESIGN_VARIANTS,
	...IT_SUPPORT_VARIANTS,
	...OTHER_PERSONAL_VARIANTS,
	...MARKETING_VARIANTS,
	...OPERATIONS_VARIANTS,
	...EVERYTHING_ELSE_VARIANTS,
};

export const TAILORED_ONBOARDING = {
	taskList: TASK_LIST,
	taskVariants: TASK_VARIANTS,
} as const;
